export default "__VITE_ASSET__kzyeU$OH__"